import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useCancellations = () => {
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  const { requestCancellationPin, cancelAssignment: apiCancelAssignment } =
    useWexClient();

  const handleRequest = async (callback, defaultMessage) => {
    setLoader(true);
    setError(null);

    try {
      const response = await callback();

      if (
        response &&
        (response.success === true || response.success === false)
      ) {
        setError(response.message);
      }

      return response;
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || defaultMessage;

      setError(message);

      return {
        success: false,
        message,
      };
    } finally {
      setLoader(false);
    }
  };

  const sendCancellationPin = async (body) => {
    return handleRequest(
      () => requestCancellationPin(body),
      "Error al solicitar PIN de cancelación",
    );
  };

  const cancelAssignment = async (body = {}) => {
    return handleRequest(
      () => apiCancelAssignment(body),
      "Error al cancelar asignación",
    );
  };

  return {
    sendCancellationPin,
    cancelAssignment,
    loader,
    error,
  };
};

export default useCancellations;
